import React, { Component } from 'react';
import TransparentButton from '../../../../../../shared/button/transparent-button/TransparentButton';
import { redirectToUserDetails } from '../../../../../../routing/redirectService';
import './TeamUsersList.scss';
import { EmptyList } from '../../../../../../shared/empty-list/EmptyList';
import { SpinLoader } from '../../../../../../shared/spin-loader/SpinLoader';

const team_users_headers = [
    { key: 'NAME', value: 'NAME', showArrowSort: false },
    { key: 'SURNAME', value: 'SURNAME', showArrowSort: false },
    { key: 'EMAIL', value: 'EMAIL', showArrowSort: false },
    { key: null, value: '' } /* This is the actions column. */
];

export class TeamUsersList extends Component {
    render = () => {
        const { users, loading, removeUserFromTeam } = this.props;
        return (
            <div className={'team-users-list table'}>
                <table>
                    <tbody>
                        <tr className="headers">
                            {team_users_headers.map(header => (
                                <th key={header.key}>{header.key}</th>
                            ))}
                        </tr>
                        {loading ? (
                            <tr>
                                <td colSpan={team_users_headers.length}>
                                    <SpinLoader />
                                </td>
                            </tr>
                        ) : (
                            (users &&
                                users.length &&
                                users.map(user => {
                                    return (
                                        <tr key={user.id}>
                                            <td>{user.firstName}</td>
                                            <td>{user.lastName}</td>
                                            <td>{user.email}</td>
                                            <td colSpan={3}>
                                                <div
                                                    className={'users-actions'}
                                                >
                                                    <TransparentButton
                                                        onClick={() =>
                                                            removeUserFromTeam(
                                                                user
                                                            )
                                                        }
                                                    >
                                                        Remove
                                                    </TransparentButton>
                                                    <TransparentButton
                                                        onClick={() =>
                                                            redirectToUserDetails(
                                                                user.id
                                                            )
                                                        }
                                                    >
                                                        Profile
                                                    </TransparentButton>
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })) || (
                                <tr>
                                    <td
                                        className={'empty-list'}
                                        colSpan={team_users_headers.length}
                                    >
                                        <EmptyList />
                                    </td>
                                </tr>
                            )
                        )}
                    </tbody>
                </table>
            </div>
        );
    };
}
